const semantic = {
    // https://www.golinuxcloud.com/javascript-recursive-search-array-of-objects/
    recursiveFind: (array, element, type) => {
        for (let obj of array) {
            if (obj === element) {
                switch (type) {
                    case "array":
                        return array;
                    case "object":
                        return obj;
                }
            }

            if (obj.children) {
                let result = recursiveFind(obj.children, element, type);
                if (result) {
                    return result;
                }
            }
        }

        return undefined;
    },
    recursiveFindArray: (array, element) => {
        return recursiveFind(array, element, 'array');
    },
    recursiveFindObject: (array, element) => {
        return recursiveFind(array, element, 'object');
    },
};

export default semantic;
export const {
    recursiveFind,
    recursiveFindArray,
    recursiveFindObject
} = semantic;
